import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import ListEmptyState from '@components/v2/ui/EmptyState/ListEmptyState';
import CatalogsIllustration from '@components/v2/ui/EmptyState/svg/CatalogsIllustration';
import LangEnum from '../../../../../lang/LangEnum';
import { CatalogTestIds } from '../../../../../utils/testIds/catalog.testIds';

interface CatalogListEmptyStateProps {
  isFiltered: boolean;
  canCreate: boolean;
  onCreate: () => void;
}

const CatalogListEmptyState = ({ isFiltered, canCreate, onCreate }: CatalogListEmptyStateProps) => {
  return (
    <ListEmptyState
      hasActiveFilters={isFiltered}
      noResultsTestId={CatalogTestIds.CATALOG_EMPTY_STATE}
    >
      <EmptyState
        title={{ text: LangEnum.CATALOGS_TITLE }}
        description={{ text: LangEnum.CATALOGS_LIST_EMPTY_DESCRIPTION }}
        illustration={<CatalogsIllustration />}
        testId={CatalogTestIds.CATALOG_EMPTY_STATE}
        action={
          canCreate
            ? { primary: { label: LangEnum.GLOBAL_CREATE_NEW_CATALOG, onClick: onCreate } }
            : undefined
        }
      />
    </ListEmptyState>
  );
};

export default CatalogListEmptyState;
